import React from 'react';
import Image from '@components/Image';
import Icons from '@components/Icons';
import FooterHome from '@components/FooterHome';

import { Container, IconWrapper, Content } from './styles';
import { Link } from 'gatsby';
import { NavLinks } from '@patterns/Navigation';

const Hero = ({ backgroundImage }) => {
  return (
    <Container>
      <Content>
        <IconWrapper>
          <Icons icon="completeLogo" />
        </IconWrapper>

        <Image absolute src={backgroundImage.file.url} />

        <NavLinks home />
      </Content>
      <FooterHome />
    </Container>
  );
};

export default Hero;
